export const URL_APPEND = '' //'http://localhost:8000' //'/highlights'
// export const API_APPEND = 'http://localhost:8000' + '/api/highlights'  // '/api/v1'
export const API_APPEND = location.origin + '/api/highlights'
export const ORIGINPATH = location.origin + URL_APPEND